


















import {Component, Prop, Vue} from 'vue-property-decorator';
import { v4 as uuid } from 'uuid';
import { WebsocketChannelDetails } from '@/types';

@Component
export default class WebsocketIntegration extends Vue {
  @Prop() private integrationDetails!: WebsocketChannelDetails;

  private beforeMount() {
    if (!this.integrationDetails.token) {
      this.integrationDetails.token = uuid();
    }

    const endpoint = `${process.env.VUE_APP_WS_ENDPOINT}?token=${this.integrationDetails.token}`;
    this.$emit('update:detail', {key: 'endpoint', value: endpoint});
  }
}
